// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type ComponentType } from 'react';
import ViewTracker from '@atlassian/jira-analytics-web-react/src/components/view-tracker.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import Flags from '@atlassian/jira-servicedesk-automation-common/src/flags';
import { automationSummaryPageLoad } from '@atlassian/jira-servicedesk-automation-common/src/performance-analytics';
import type { Flag } from '@atlassian/jira-servicedesk-automation-common/src/state/flags/types';
import PageSpinner from '@atlassian/jira-servicedesk-common/src/ui/components/page-spinner';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';

export type Props = {
	isLoading: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	LayoutComponent: ComponentType<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	JsmPageInteractiveEvent: ComponentType<any>;
	flags: Flag[];
	onFlagDismissed: (arg1: string | number) => void;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onMount: (arg1?: any) => void;
};

// eslint-disable-next-line jira/react/no-class-components
export default class View extends PureComponent<Props> {
	static defaultProps = {
		isLoading: false,
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onMount: () => {},
	};

	componentDidMount() {
		this.props.onMount();
	}

	render() {
		const { isLoading, flags, onFlagDismissed, LayoutComponent, JsmPageInteractiveEvent } =
			this.props;

		if (isLoading) {
			return <PageSpinner />;
		}
		// In Next-gen projects, we want to use the sweet-state store provided by the breadcrumb manager rendered in spa-apps' AppContainer wrapper, instead of adding another breadcrumb store at this level.
		return (
			<>
				<ViewTracker />
				<JsmPageInteractiveEvent
					appName="servicedesk.automation"
					metric={automationSummaryPageLoad}
				/>
				<Flags flags={flags} onDismissed={onFlagDismissed} />
				<LayoutComponent />
				{/* SpaStatePageReady is used to indicate that the app can move to the "afterPaint" phase in react-loosely-lazy. */}
				{fg('jsm_simplified_project_settings_navigation') && <SpaStatePageReady />}
			</>
		);
	}
}
